import Button, { ButtonProps } from '@material-ui/core/Button'
import React, { MouseEvent } from 'react'

import { useAnalytics } from '../../lib/analytics'

interface TrackedButtonProps extends ButtonProps {
  tracking: {
    action: string
    category: string
    label: string
  }
}

const TrackedButton = ({ children, onClick, tracking, ...props }: TrackedButtonProps) => {
  const { trackEvent } = useAnalytics()

  const onClickHandler = (e: MouseEvent<HTMLButtonElement>) => {
    if (onClick) onClick(e)
    trackEvent({
      action: tracking.action,
      category: tracking.category,
      label: tracking.label,
      location: tracking.category,
    })
  }

  return (
    <Button onClick={onClickHandler} {...props}>
      {children}
    </Button>
  )
}

export default TrackedButton
